var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 515.9 515.9",
    style: {
      enableBackground: "new 0 0 515.9 515.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M449.6,192.5C449.4,89.5,367.5,5.3,265.5,1.4l-2.4-0.1h-2.4l-2.5-0.1h-2.5l-2.4,0l-2.4,0.1C148.8,5.3,67,89.5,67,192.5 c0,2.2,0,4.4,0.1,6.7c-0.1,2.4-0.1,4.8-0.1,7.1c0,12.9,1.1,25.8,3.4,38.5c0.1,0.8,0.5,3,1.3,6.9c2.9,13.9,7.2,27.4,12.8,40.4 c20.6,52,65.9,131.9,165.3,217.5c4.9,4.3,12.1,4.3,17,0c99.3-85.6,144.7-165.5,165.3-217.5c5.6-13,9.9-26.6,12.8-40.4 c0.8-3.9,1.2-6.1,1.3-6.9c2.2-12.7,3.4-25.6,3.4-38.5c0-2.4,0-4.8-0.1-7.2C449.5,196.9,449.6,194.7,449.6,192.5z M352.3,201.3 c-3.7,52-48.9,91.1-100.9,87.4c-46.8-3.3-84.1-40.6-87.4-87.4c-0.2-2.2-0.3-4.5-0.3-6.8c0-52.1,42.3-94.4,94.4-94.4 c52.1,0,94.4,42.3,94.4,94.4C352.6,196.8,352.5,199.1,352.3,201.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.2c4d5990.svg";
export { ForwardRef as ReactComponent };